import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import React, { useState, useEffect } from "react";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { ValSpecialCharacters } from "../../../Validators/ValSpecialCharacters";
import WarningIcon from "@mui/icons-material/Warning";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";

import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import { ValFormReg } from "../../../Validators/ValForms";
import { RegularExpressions } from "../../../Helpers/RegularExpression";


const MdlValidacionPedidoJDF = ({
    folio,
    setLoader,
    loader,
    iddocumentopedido = 25,
    idproceso = 1010,
    updateComentarios,
    // Inyectado por ModalSolicitudCreditoJDF (ver ModalSCScreens). Habilita
    // "Siguiente" tras aceptar, sin cerrar el modal.
    habilitarSiguiente,
}) => {
    const [comentarios, setComentarios] = useState("");
    const [estatus, setEstatus] = useState({});
    const [open, setOpen] = useState(false); // Estado para controlar si el modal está abierto o cerrado
    const [selectedDate, setSelectedDate] = useState('');
    const onChange = (prop, value, sbool, smensaje) => {
        setComentarios(value);
    };

  




    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ACPedidoEstado/Get?folio=${folio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setEstatus(result);

                const fechaSoloFecha = result.fecha_pagare.split('T')[0];
                setSelectedDate(fechaSoloFecha);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    }, []);
    const onImprimirArchivo = () => {
        setLoader({ ...loader, mostrar: true });
        const iddocumento = iddocumentopedido;
        request
            .get(
                `SolicitudCreditoDocumentacion/ObtenerDocumentoPedido?folio=${folio}&iddocumento=${Number(
                    iddocumento
                )}`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = result.documento;
                const downloadLink = document.createElement("a");
                const fileName = `${result.nombredocumento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("ANALISIS DE SOLICITUD DE CREDITO", error.mensaje, "error");
            });
    };

    const onAceptar = () => {
        const rescomentarios = ValFormReg(
            "Comentarios",
            comentarios,
            RegularExpressions.TextSpecialCharacter,
            15,
            2000
        );
        if (rescomentarios.isValid === false) {
            Swal.fire(
                "ANALISIS DE SOLICITUD DE CREDITO",
                rescomentarios.mensaje,
                "error"
            );
            return;
        }
        setLoader({ ...loader, mostrar: true });
        const post = {
            folio,
            idproceso,
            consecutivo: -1,
            comentarios,
            estatus: "A",
        };
        request
            .post("ACTimeLineComentarios/GuardarComentario", post)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setEstatus(result.estado);

                setComentarios("");
                if (updateComentarios !== undefined && updateComentarios !== null)
                    updateComentarios();

                // Habilita "Siguiente" sin recargar data/estado ni cerrar el modal.
                if (habilitarSiguiente !== undefined && habilitarSiguiente !== null)
                    habilitarSiguiente();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    };
    const OnGetIcon = ({ icon }) => {
        switch (icon) {
            case "wait":
                return <PendingIcon />;
            case "success":
                return <CheckCircleIcon />;
            case "warning":
                return <WarningIcon />;
            case "error":
                return <ErrorIcon />;
            default:
                <></>;
        }
    };

    const onDescargarPedido = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`PedidoImpresion/ReportePDF?folio=${folio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = `data:application/pdf;base64, ${result.documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${result.nombredocumento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("Clientes", JSON.stringify(error), "error");
            });
    };

    const onDescargarPagare = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`Pagares/ImprimirPagare?folio=${folio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                if (result.length > 0) {
                    result.forEach((documento, index) => {
                        const linkSource = `data:application/pdf;base64, ${documento.documento}`;
                        const downloadLink = document.createElement("a");
                        const fileName = `${documento.nombredocumento}-${index + 1}.${documento.extension
                            }`; // Añade el número de documento al nombre del archivo
                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();
                    });
                } else {
                    Swal.fire(
                        "Clientes",
                        "No se encontraron documentos para descargar",
                        "info"
                    );
                }
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("Clientes", JSON.stringify(error), "error");
            });
    };

    const onEnviarModificar = (accion) => {
        const rescomentarios = ValFormReg(
            "Comentarios",
            comentarios,
            RegularExpressions.TextSpecialCharacter,
            15,
            2000
        );
        if (rescomentarios.isValid === false) {
            Swal.fire(
                "ANALISIS DE SOLICITUD DE CREDITO",
                rescomentarios.mensaje,
                "error"
            );
            return;
        }
        setLoader({ ...loader, mostrar: true });
        const post = {
            folio,
            idproceso,
            consecutivo: -1,
            comentarios,
            estatus: accion,
            fecha_pagare: selectedDate,
        };
        request
            .post("ACTimeLineComentarios/EnviarModificar", post)
            .then((result) => {
                setLoader({ ...loader, mostrar: false })
                handleClose()
                // setEstatus(result.estado);
                //
                // setComentarios("");
                // if (updateComentarios !== undefined && updateComentarios !== null)
                //   updateComentarios();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    };

    // Función para abrir el modal
    const handleClickOpen = () => {
        const rescomentarios = ValFormReg(
            "Comentarios",
            comentarios,
            RegularExpressions.TextSpecialCharacter,
            15,
            2000
        );
        if (rescomentarios.isValid === false) {
            Swal.fire(
                "ANALISIS DE SOLICITUD DE CREDITO",
                rescomentarios.mensaje,
                "error"
            );
            return;
        }

        setOpen(true);
    };

    // Función para cerrar el modal
    const handleClose = () => {
        setOpen(false);
    };

    // Función para manejar el cambio en el input de tipo date
    const handleDateChange = (event) => {
        setSelectedDate(event.target.value);
    };

    return (
        <div className="analisis-credito-modal-mhusa">
            <div className="analisis-credito-modal-mhusa-content">
                <div className="analisis-credito-modal-mhusa-content-buttons">
                    <div
                        className={"analisis-credito-modal-mhusa-content-pdf"}
                        onClick={() => onDescargarPedido()}
                    >
                        <CloudDownloadIcon />
                        <div>Descargar pedido original</div>
                    </div>
                    <div
                        className={"analisis-credito-modal-mhusa-content-pdf"}
                        onClick={() => onDescargarPagare()}
                    >
                        <CloudDownloadIcon />
                        <div>Descargar pagare original</div>
                    </div>
                    {estatus.habilitar === undefined ||
                        estatus.habilitar === null ||
                        estatus.habilitar === false ? (
                        <div
                            className={`analisis-credito-modal-mhusa-content-comentarios analisis-credito-modal-pedido-content-comentarios-${estatus.icono}`}
                        >
                            <div className="analisis-credito-modal-mhusa-content-comentarios-svg">
                                <OnGetIcon icon={estatus.icono} />
                            </div>
                            <div className="analisis-credito-modal-mhusa-content-comentarios-div">
                                {estatus.comentarios}
                            </div>
                        </div>
                    ) : (
                        <div className="analisis-credito-modal-mhusa-content-buttons-container">
                            <TextField
                                fullWidth
                                size="small"
                                label="COMENTARIOS"
                                className="cel-1"
                                multiline
                                rows={4}
                                type="text"
                                // error={condiciones.bcondiciones}
                                onChange={({ target }) => {
                                    ValSpecialCharacters(
                                        "condiciones",
                                        target.value,
                                        onChange,
                                        true,
                                        500
                                    );
                                }}
                                value={comentarios}
                            />
                            <div className="analisis-credito-modal-mhusa-content-buttons-container-buttons">
                                <div
                                    className="analisis-credito-modal-mhusa-content-acept-button"
                                    onClick={() => {
                                        onAceptar();
                                    }}
                                >
                                    <CheckCircleIcon />
                                    <div>Aceptar condiciones de la operación</div>
                                </div>
                                <div
                                    className="analisis-credito-modal-mhusa-content-warning-button"
                                    onClick={() => handleClickOpen()}
                                >
                                    <WarningIcon />
                                    <div>Solicitar cambio en las condiciones</div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                {/* Modal usando el componente Dialog de MUI */}
                <Dialog open={open} onClose={handleClose}>
                    <DialogTitle>Selecciona una fecha para el pagare</DialogTitle>
                    <DialogContent>
                        {/* Input tipo date */}
                        <input
                            type="date"
                            value={selectedDate}
                            onChange={handleDateChange}
                            style={{ width: '100%', height: '30px' }}
                        />
                    </DialogContent>
                    <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        {/* Botón de Cerrar alineado a la izquierda */}
                        <Button onClick={handleClose} color="primary" sx={{ alignSelf: 'flex-start' }}>
                            Cerrar
                        </Button>

                        {/* Botón de Guardar alineado a la derecha */}
                        <Button
                            onClick={() => onEnviarModificar("M")}
                            color="primary"
                            sx={{ alignSelf: 'flex-end' }}>
                            Guardar
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>
    );
};

export default MdlValidacionPedidoJDF;